import { EstimateStatus } from "@rebuild/shared";
import { useUser } from "@/hooks/useUser";

// Custom hook to get status options for dashboard - uses custom settings if available, otherwise defaults
export const useStatusOptions = (): { value: string; id: string }[] => {
  const { currentUser } = useUser();

  // Check if custom status list exists in user settings
  if (currentUser?.extraData?.customSettings?.status && currentUser.extraData.customSettings.status.length > 0) {
    // Add ALL option first
    const allOption = { value: EstimateStatus.ALL, id: EstimateStatus.ALL };

    // Map custom statuses to options format needed by dashboard
    const customOptions = currentUser.extraData.customSettings.status.map((status) => ({
      value: status.name,
      id: status.name,
    }));

    return [allOption, ...customOptions];
  }

  // Fall back to default options if no custom statuses
  return Object.values(EstimateStatus).map((option) => ({
    value: option,
    id: option,
  }));
};
